/* eslint-disable quote-props */
/**
 * Composite score calculation constants.
 * @module calculation_constants
 *
 */

const MEASURE_WEIGHTS_BY_GRADE = {
    'KG': {
        'FNL': 12.44,
        'FSS': 7.75,
        'FSL': 11.80,
        'LSS': 8.63,
        'FEP': 7.63,
    },
    '01': {
        'FNL': 9.95,
        'FSS': 4.89,
        'FSL': 9.00,
        'LSS': 15.31,
        'FEP': 15.18,
        'FLO': 17.54,
        'FLO-ACC': 0.25,
    },
    '02': {
        'FEP': 17.66,
        'FLO': 28.33,
        'FLO-ACC': 0.14,
        'CLPL': 2.24,

    },
    '03': {
        'FEP': 13.97,
        'FLO': 27.07,
        'FLO-ACC': 0.10,
        'CLPL': 3.64,
    },
    '04': {
        'FLO': 25.36,
        'FLO-ACC': 0.06,
        'CLPL': 3.07,
    },
    '05': {
        'FLO': 27.54,
        'FLO-ACC': 0.04,
        'CLPL': 3.37,
    },
    '06': {
        'FLO': 23.01,
        'FLO-ACC': 0.01,
        'CLPL': 3.12,
    },
};

const MEAN_BY_GRADE_PERIOD = {
    'KG': {
        'BOY': 474.76,
        'MOY': 918.14,
        'EOY': 1310.78,
    },
    '01': {
        'BOY': 1356.73,
        'MOY': 2003.48,
        'EOY': 2606.04,
    },
    '02': {
        'BOY': 1474.21,
        'MOY': 2077.37,
        'EOY': 2323.33,
    },
    '03': {
        'BOY': 1599.33,
        'MOY': 2177.71,
        'EOY': 2797.71,
    },
    '04': {
        'BOY': 1597.57,
        'MOY': 1720.89,
        'EOY': 1903.04,
    },
    '05': {
        'BOY': 1943.79,
        'MOY': 2672.78,
        'EOY': 2641.76,
    },
    '06': {
        'BOY': 1789.55,
        'MOY': 1851.20,
        'EOY': 2306.51,
    },
};

// SD - Standard Deviation
const SD_BY_GRADE_PERIOD = {
    'KG': {
        'BOY': 362.19,
        'MOY': 449.45,
        'EOY': 541.19,
    },
    '01': {
        'BOY': 876.27,
        'MOY': 1027.02,
        'EOY': 1195.85,
    },
    '02': {
        'BOY': 1028.24,
        'MOY': 1164.32,
        'EOY': 1251.60,
    },
    '03': {
        'BOY': 818.99,
        'MOY': 976.99,
        'EOY': 1060.52,
    },
    '04': {
        'BOY': 691.25,
        'MOY': 659.87,
        'EOY': 663.12,
    },
    '05': {
        'BOY': 585.98,
        'MOY': 871.10,
        'EOY': 982.04,
    },
    '06': {
        'BOY': 740.48,
        'MOY': 583.55,
        'EOY': 658.56,
    },
};

const SCORE_OFFSET_CONSTANT_BY_GRADE_PERIOD = {
    'KG': {
        'BOY': 289,
        'MOY': 364,
        'EOY': 398,
    },
    '01': {
        'BOY': 360,
        'MOY': 400,
        'EOY': 440,
    },
    '02': {
        'BOY': 360,
        'MOY': 400,
        'EOY': 440,
    },
    '03': {
        'BOY': 360,
        'MOY': 400,
        'EOY': 440,
    },
    '04': {
        'BOY': 360,
        'MOY': 400,
        'EOY': 440,
    },
    '05': {
        'BOY': 360,
        'MOY': 400,
        'EOY': 440,
    },
    '06': {
        'BOY': 360,
        'MOY': 400,
        'EOY': 440,
    },
};

const COMPOSITE_SCORE_MULTIPLIER = 40;

module.exports = {
    COMPOSITE_SCORE_MULTIPLIER,
    MEAN_BY_GRADE_PERIOD,
    MEASURE_WEIGHTS_BY_GRADE,
    SCORE_OFFSET_CONSTANT_BY_GRADE_PERIOD,
    SD_BY_GRADE_PERIOD,
};
